<template>
  <div id="fuiTop" class="base-back fui-top">
    <div id="fuiLogo">
      <a href="javascript:">
        <img src="./hr.png" id="logo" />
      </a>
    </div>
    <div id="sysList" class="collapse navbar-collapse">
      <ul class="nav navbar-nav navbar-right">
        <li class="nav-system" v-for='item in user.menuList' :key='item.autoid'>
          <a href="javascript:" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{item.nameZh}}
            <span v-if="item.hc" class="caret"></span>
          </a>
          <ul v-if="item.hc" class="dropdown-menu" >
              <li v-for='xitem in item.child' :key='xitem.autoid'>
                <a v-if="xitem.link" href="javascript:" @click.ctrl='gotoNewPage($baseUrl + xitem.link)' @click='gotoPage($event, $baseUrl + xitem.link, xitem.nameZh)'>{{xitem.nameZh}}</a>
              </li>
          </ul>
        </li>        
        <li>
          <a href="javascript:" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            我的
            <span class="caret"></span>
          </a>
          <ul class="dropdown-menu">
            <li class="dropdown-header">
              <span style="font-size:22px">{{user.name}}</span>
            </li>
            <li role="separator" class="divider"></li>
            <li :class="tcls">
              <a href="javascript:" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                <span class="glyphicon glyphicon-tree-conifer" aria-hidden="true"></span> 皮肤
              </a>
              <ul class="dropdown-menu">
                <li class="ui-black">
                  <a href="javascript:" @click.stop='changeThemes("fui-black")'>
                    <span class="glyphicon glyphicon-tree-conifer" aria-hidden="true"></span>护眼
                  </a>
                </li>
                <li class="ui-blue">
                  <a href="javascript:" @click.stop='changeThemes("fui-blue")'>
                    <span class="glyphicon glyphicon-tree-conifer" aria-hidden="true"></span>天空蓝
                  </a>
                </li>
                <li class="ui-violet">
                  <a href="javascript:" @click.stop='changeThemes("fui-violet")'>
                    <span class="glyphicon glyphicon-tree-conifer" aria-hidden="true"></span>紫罗兰
                  </a>
                </li>
                <li class="ui-green">
                  <a href="javascript:" @click.stop='changeThemes("fui-green")'>
                    <span class="glyphicon glyphicon-tree-conifer" aria-hidden="true"></span>青草绿
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="javascript:">
                <span class="glyphicon glyphicon-font" aria-hidden="true"></span> Font Size
              </a>
            </li>
            <li role="separator" class="divider"></li>
            <li>
              <a id="btnLogout" href="javascript:" v-on:click="Logout">
                <span class="glyphicon glyphicon-off" aria-hidden="true"></span> Logout
              </a>
            </li>
          </ul>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: "fuitop",
  props: ["user", "themes"],
  data(){
    return {
      tcls: this.themes? "dropdown-submenu " +this.themes:"dropdown-submenu fui-black"
    }
  },
  methods: {
    Logout: function() {
      this.$getData("login/logout", (data) => {
        this.user.isLogin = false;
        this.$router.push("/login");
      })
    },
    changeThemes(cls){
      this.tcls = "dropdown-submenu " + cls
      this.$emit("resetThemes", cls)
      //this.$parent.$data.tcls = cls
    },
    gotoPage(e, link, title){
      if (e.ctrlKey) return
      document.title = title
      this.$router.push(link)
    },
    gotoNewPage(link, title){
      //document.title = title
      window.open(link)
      return false
    }
  }
};
</script>
